var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"w-full px-3 py-3 | transition duration-300 | hover:text-gray-900",attrs:{"active-class":"rounded shadow-lg text-blue-500 bg-white transform-none | hover:text-blue-500","to":_vm.to}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }